const useCurrentTimeZone = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timeZone;
};

export default useCurrentTimeZone;
